// Libs
import React from 'react';
// Components
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';
// Styles
import styles from './SimpleLine.module.css';

const SimpleLine = ({ data, config = {} }) => {
	const {
		width = 500,
		height = 300,
		values = ['uv', 'pv'],
		stroke = {
			area1: '#8884d8',
			area2: '#82ca9d',
		},
		xDataKey = 'name',
	} = config;
	return (
		<div className={styles.lineContainer} style={{ width, height }}>
			<ResponsiveContainer width='100%' height='100%'>
				<LineChart
					width={width}
					height={height}
					data={data}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5,
					}}
				>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis dataKey={xDataKey} />
					<YAxis />
					<Tooltip />
					<Legend />
					<Line
						type='monotone'
						dataKey={values[0]}
						stroke={stroke.area1}
						activeDot={{ r: 8 }}
					/>
					<Line type='monotone' dataKey={values[1]} stroke={stroke.area2} />
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
};

export default SimpleLine;
